export default {
  en: {
    title: 'Dictionary',
    phraseTitle: 'Phrase',
    added: 'Added',
    addToStudy: 'Add to study',
    loadError: 'Couldn’t load the word. Try again.',
    listen: 'Listen',
    noTranslationFound: 'No translation found.',
    loadingWord: 'Loading word',
  },
  ru: {
    title: 'Словарь',
    phraseTitle: 'Фраза',
    added: 'Добавлено',
    addToStudy: 'В изучение',
    loadError: 'Не получилось загрузить слово. Попробуй ещё раз.',
    listen: 'Озвучить',
    noTranslationFound: 'Перевод не найден.',
    loadingWord: 'Загружаю слово',
  },
};
